import type { RequestConfig } from '@customTypes/index';
import type { RequestRegistrationItem } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetRegistrationRequestList = RequestConfig;

export const getRegistrationRequestList = async ({
  config
}: GetRegistrationRequestList) =>
  api.get<RequestRegistrationItem[]>(`/api/registrationrequests`, config);
